import { visit } from 'unist-util-visit'; // or: `import { visit } from 'unist-util-visit'` if using v5+

import type { Root } from 'mdast';
import type { ContainerDirective, LeafDirective, TextDirective } from 'mdast-util-directive';
import type { Plugin } from 'unified';
import type { Node } from 'unist';

type Directive = ContainerDirective | LeafDirective | TextDirective;

export const remarkCustomDirectives: Plugin<[], Root> = () => {
  return (tree: Root) => {
    visit(tree, ['textDirective', 'leafDirective', 'containerDirective'], (node: Node) => {
      const directive = node as Directive;
      const data = directive.data ?? (directive.data = {});
      const tagName = directive.name || 'div';

      data.hName = tagName;
      data.hProperties = directive.attributes || {};
    });
  };
};
